module.exports = __webpack_public_path__ + "static/media/dummy_stamp.fb6cac97.png";